/**
 * Created by hp on 2017/6/26.
 */
import React,{Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-weui';

class ChannelMonthPayChannel extends Component {
    constructor() {
        super();
        this.handleMonthChannel = this.handleMonthChannel.bind(this);
    }

    handleMonthChannel() {
        this.props.dispatch({
            type: 'CHANNEL_SHOW_PAY_PANEL'
        })
    }

    render() {
        return(
            <Button className="weui-flex__item flex_3" onClick={this.handleMonthChannel}>购买专栏</Button>
        )
    }
}

export default connect((state) => ({

}))(ChannelMonthPayChannel)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelMonthPayChannel.js